export default __webpack_public_path__ + "static/media/refresh-btn.118ad7f5.svg";